import api from '../../services/api';
import { mapClientFields } from '../../services/client';
import { DeviceInputData } from '../../services/serial';
import { Client } from '../../services/typings';

const CLIENT_URL = '/api/food_counter/client';

export const DEFAULT_CLIENT: Client = {
  userId: -1,
  clientId: -1,
  credit: 0,
  fullName: '',
  email: '',
  canPurchase: false,
  orders: [],
  hasPendingTransations: false,
};

export async function fetchClientWithRetry(
  { codeType, code }: DeviceInputData,
  warehouseId: number,
): Promise<Client | null> {
  let url: string = `${CLIENT_URL}?warehouse=${warehouseId}`;

  if (codeType === 'rfid') {
    url += `&badge=${code}`;
  } else if (codeType === 'qrcode') {
    url += `&jwt=${code}`;
  }

  const response = await api.get(url);
  const client = mapClientFields(response.data);
  return client || null;
}

export interface SearchClientOption {
  label: string;
  value: string;
}
